import React, { useEffect, useState } from 'react';
import './public-list-view-overlay.scss';
import ArrowIcon from '../../util/icons/components/ArrowIcon';

const PublicListViewOverlay = () => {
  const [ hidden, setHidden ] = useState(false)
  useEffect(() => {
    let timeout = setTimeout(() => setHidden(true), 2 * 1000);
    return () => clearTimeout(timeout);
  }, []);
  const className = hidden ? 'hidden' : '';
  return (
    <div id="public-list-view-overlay" className={ className }>
      <div className="center">
        <h1 data-cy="home-page-title" className="title">
          <span className="good">Good</span><span className="beef">Beef</span>
          <br/>
          <span className="good-for-you">is good for you</span>
        </h1>
        <ArrowIcon />
      </div>
    </div>
  );
};

export default PublicListViewOverlay;